import React from 'react'
import { makeStyles } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'

const useStyles = makeStyles({
  loading: {
    position: 'fixed',
    height: '100vh',
    width: '100vw',
    background: 'rgba(0,0,0, 0.35)',
    left: 0,
    top: 0,
    '& > div': {
      position: 'absolute',
      left: '50%',
      top: '50%',
    },
  },
})
interface LoadingProps {}

const Loading = () => {
  const classes = useStyles()

  return (
    <div className={classes.loading}>
      <CircularProgress />
    </div>
  )
}

export default Loading
